import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-soccer.svg";
import * as styles from "./Icon.module.scss";

type SoccerProps = React.SVGProps<SVGSVGElement>;

export const Soccer = ({ className, ...props }: SoccerProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
